import React, { useState } from "react";
import { EditOutlined, DeleteOutlined } from "@ant-design/icons";
import CustomTable from "../components/Table";

const Pipeline = () => {
  const [pageSize, setPageSize] = useState(10);
  const [searchText, setSearchText] = useState("");

  const data = [
    { key: "1", name: "Sales", value: "68,85,000", deals: 316, stage: "Won", date: "14 Nov 2024", status: "Active" },
    { key: "2", name: "Marketing", value: "5,45,000", deals: 447, stage: "In Pipeline", date: "14 Nov 2024", status: "Active" },
    { key: "3", name: "Calls", value: "0,000", deals: 654, stage: "Won", date: "14 Nov 2024", status: "Active" },
    { key: "4", name: "Email", value: "45,55,000", deals: 545, stage: "Follow Up", date: "14 Nov 2024", status: "Inactive" },
  ];

  const filteredData = data.filter((item) =>
    item.name.toLowerCase().includes(searchText.toLowerCase())
  );

  const columns = [
    { title: "", render: () => <input type="checkbox" />, width: 50 },
    { title: "Pipeline Name", dataIndex: "name" },
    { title: "Total Deal Value", dataIndex: "value" },
    { title: "No of Deals", dataIndex: "deals" },
    { title: "Stage", dataIndex: "stage" },
    { title: "Created Date", dataIndex: "date" },
    { title: "Status", dataIndex: "status" },
    {
      title: "Action",
      render: () => (
        <div className="action-icons">
          <EditOutlined />
          <DeleteOutlined />
        </div>
      ),
    },
  ];

  return (
    <CustomTable
      title="Pipeline List"
      columns={columns}
      data={filteredData}
      pageSize={pageSize}
      setPageSize={setPageSize}
      onSearch={setSearchText}
    />
  );
};

export default Pipeline;